import { Typography } from "@material-ui/core";

import { useStyles } from "./ListCard.styles";

type TertiaryRowProps = {
  tertiary?: string[];
};

const TertiaryRow = ({ tertiary }: TertiaryRowProps): JSX.Element => {
  const classes = useStyles();

  if (tertiary && tertiary.length > 2) {
    const firstLine = tertiary.slice(0, 2).join(" · ");
    const secondLine = tertiary.slice(2).join(" · ");
    return (
      <>
        <Typography noWrap className={classes.subtitleFont}>
          {firstLine}
        </Typography>
        <Typography noWrap className={classes.subtitleFont}>
          {secondLine}
        </Typography>
      </>
    );
  }
  return (
    <Typography noWrap className={classes.subtitleFont}>
      {tertiary?.join(" · ")}
    </Typography>
  );
};

export { TertiaryRow };
